import { useCallback, useEffect, useMemo, useState } from "react";
import { api, mesajEroare } from "./api.js";
import { SURSA_ECHIPAMENT, eticheta } from "./enums.js";
import { data, normalizeaza } from "./text.js";
import { tr } from "./i18n.js";

const ADMINISTRARE = ["ADMIN_TENANT", "MANAGER_TEHNIC", "COORDONATOR"];

const STARI = [
  { cod: "Functional", titlu: "Funcțional" },
  { cod: "Degradat", titlu: "Degradat" },
  { cod: "Nefunctional", titlu: "Nefuncțional" },
  { cod: "ScosDinFunctiune", titlu: "Scos din funcțiune" },
];

const CRITICITATI = [
  { cod: "Scazuta", titlu: "Scăzută" },
  { cod: "Medie", titlu: "Medie" },
  { cod: "Ridicata", titlu: "Ridicată" },
  { cod: "Critica", titlu: "Critică" },
];


export default function Parc({ eu }) {
  const [clienti, setClienti] = useState([]);
  const [clientId, setClientId] = useState("");
  const [arbore, setArbore] = useState([]);
  const [aratScoase, setAratScoase] = useState(false);
  const [cauta, setCauta] = useState("");
  const [rezultate, setRezultate] = useState(null);
  const [scadentar, setScadentar] = useState(null);
  const [echipamentDeschis, setEchipamentDeschis] = useState(null);
  const [formSistem, setFormSistem] = useState(false);
  const [formEchipament, setFormEchipament] = useState(null);
  const [incarca, setIncarca] = useState(false);
  const [eroare, setEroare] = useState("");

  const poateAdministra = ADMINISTRARE.includes(eu.rol);

  useEffect(() => {
    api.clienti().then((l) => {
      setClienti(l);
      if (l.length === 1) setClientId(l[0].id);
    }).catch((e) => setEroare(mesajEroare(e)));
    api.scadentar(30).then(setScadentar).catch(() => {});
  }, []);

  const reincarca = useCallback(async () => {
    if (!clientId) { setArbore([]); return; }
    setIncarca(true);
    try { setArbore(await api.parc(clientId, aratScoase)); }
    catch (e) { setEroare(mesajEroare(e)); }
    finally { setIncarca(false); }
  }, [clientId, aratScoase]);

  useEffect(() => { reincarca(); }, [reincarca]);

  const cautaAcum = async (termen) => {
    setCauta(termen);
    if (termen.trim().length < 2) { setRezultate(null); return; }
    try { setRezultate(await api.cautaEchipament(termen.trim(), clientId || undefined)); }
    catch (e) { setEroare(mesajEroare(e)); }
  };

  const totalEchipamente = useMemo(
    () => arbore.reduce((n, l) => n + l.sisteme.reduce((m, s) => m + s.numarEchipamente, 0), 0),
    [arbore],
  );

  return (
    <div className="continut">
      <h1>{tr("Parc instalat")}</h1>
      <p className="subtitlu">
        {tr("Ce e montat la client, din ce e format, în ce stare, în garanție până când. Nimic nu se șterge: ce iese din funcțiune rămâne, cu motiv și istoric.")}
      </p>

      {eroare && <div className="eroare">{eroare}</div>}

      {scadentar && (scadentar.mentenanteScadente.length > 0 || scadentar.garantiiCareExpira.length > 0) && (
        <div className="panou panou-atentie">
          <div className="panou-corp">
            <strong>{tr("În următoarele")} {scadentar.fereastraZile} {tr("de zile:")}</strong>{" "}
            {scadentar.mentenanteScadente.length} {tr("mentenanțe scadente")}
            {scadentar.mentenanteScadente.some((m) => m.intarziat) && (
              <span className="marcaj">
                {scadentar.mentenanteScadente.filter((m) => m.intarziat).length} {tr("deja întârziate")}
              </span>
            )}
            {scadentar.garantiiCareExpira.length > 0 && `, ${scadentar.garantiiCareExpira.length} garanții care expiră`}.
          </div>
        </div>
      )}

      <div className="panou">
        <div className="panou-corp">
          <div className="formular-linie">
            <label>
              {tr("Client")}
              <select className="camp" value={clientId} onChange={(e) => setClientId(e.target.value)}>
                <option value="">{tr("— alege clientul —")}</option>
                {clienti.map((c) => <option key={c.id} value={c.id}>{tr(c.denumire)}</option>)}
              </select>
            </label>
            <label style={{ flex: 2 }}>
              {tr("Caută echipament")}
              <input className="camp" placeholder={tr("cod de etichetă, serie sau poziție…")}
                value={cauta} onChange={(e) => cautaAcum(e.target.value)} />
            </label>
          </div>
          <p className="nota-cautare">
            {tr("Codul de pe etichetă e stabil: eticheta lipită acum trei ani deschide tot fișa corectă.")}
          </p>
        </div>
      </div>

      {rezultate && (
        <div className="panou">
          <div className="panou-antet">
            <h2>{tr("Rezultate")}</h2><span className="numar">{rezultate.length}</span>
          </div>
          <div className="panou-corp">
            {rezultate.length === 0 ? (
              <div className="gol">{tr("Niciun echipament care să se potrivească.")}</div>
            ) : (
              <table className="tabel">
                <thead><tr><th>{tr("Etichetă")}</th><th>{tr("Cod")}</th><th>{tr("Serie")}</th><th>{tr("Client")}</th><th>{tr("Locație")}</th><th>{tr("Poziție")}</th><th></th></tr></thead>
                <tbody>
                  {rezultate.map((e) => (
                    <tr key={e.id}>
                      <td className="tip-denumire">{e.eticheta || "—"}</td>
                      <td><code className="cod-mic">{e.codQR}</code></td>
                      <td>{e.serie || "—"}</td>
                      <td>{tr(e.client?.denumire)}</td>
                      <td>{tr(e.locatie?.denumire)}</td>
                      <td>{e.pozitieFizica || "—"}</td>
                      <td className="celula-actiuni">
                        <button className="buton-mic" onClick={() => setEchipamentDeschis(e.id)}>{tr("fișa")}</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {!clientId ? (
        <div className="panou"><div className="panou-corp gol">
          {tr("Alege un client ca să-i vezi parcul.")}
        </div></div>
      ) : incarca ? (
        <div className="gol" style={{ padding: "2rem 0" }}>{tr("Se încarcă…")}</div>
      ) : (
        <>
          <div className="linie-actiune" style={{ alignItems: "center" }}>
            <label className="comutator-dezactivate">
              <input type="checkbox" checked={aratScoase} onChange={(e) => setAratScoase(e.target.checked)} />
              {tr("arată și ce e scos din funcțiune")}
            </label>
            <span className="numar">{totalEchipamente} {tr("echipamente")}</span>
            {poateAdministra && (
              <button className="buton buton-actiune" onClick={() => setFormSistem(true)}>{tr("sistem nou")}</button>
            )}
          </div>

          {arbore.length === 0 ? (
            <div className="panou"><div className="panou-corp gol">{tr("Clientul nu are locații active.")}</div></div>
          ) : arbore.every((l) => l.sisteme.length === 0) ? (
            <div className="panou"><div className="panou-corp gol">
              {tr("Niciun sistem instalat încă.")} {poateAdministra && "Începe cu „sistem nou”."}
            </div></div>
          ) : (
            arbore.filter((l) => l.sisteme.length > 0).map((loc) => (
              <div className="panou" key={loc.id}>
                <div className="panou-antet">
                  <h2>{tr(loc.denumire)}</h2>
                  {loc.oras && <span className="numar">{loc.oras}</span>}
                </div>
                <div className="panou-corp">
                  {loc.sisteme.map((s) => (
                    <div key={s.id} className="subsistem">
                      <div className="subsistem-titlu">
                        <strong>{tr(s.denumire)}</strong>
                        <code className="cod-mic">{s.tipSistem.cod}</code>
                        <span className={`pastila ${s.stare === "Functional" ? "pastila-soft" : "pastila-hard"}`}>
                          {tr(STARI.find((x) => x.cod === s.stare)?.titlu) ?? s.stare}
                        </span>
                        <span className="marcaj">{tr("criticitate")} {tr(CRITICITATI.find((c) => c.cod === s.criticitate)?.titlu)}</span>
                        <span className="numar">{s.numarEchipamente} {tr("echipamente")}</span>
                        {poateAdministra && (
                          <button className="buton-mic" onClick={() => setFormEchipament(s)}>
                            {tr("adaugă echipament")}
                          </button>
                        )}
                      </div>
                      {s.subsisteme.length === 0 ? (
                        <div className="gol">{tr("Niciun echipament înregistrat pe acest sistem.")}</div>
                      ) : (
                        s.subsisteme.map((grup) => (
                          <div key={grup.subsistem.id}>
                            <div className="rezultat-context">{tr(grup.subsistem.denumire)}</div>
                            <table className="tabel">
                              <thead>
                                <tr><th>{tr("Etichetă")}</th><th>{tr("Tip")}</th><th>{tr("Poziție")}</th><th>{tr("Serie")}</th>
                                    <th>{tr("Garanție")}</th><th></th></tr>
                              </thead>
                              <tbody>
                                {grup.echipamente.map((e) => (
                                  <tr key={e.id} className={e.scosDinFunctiuneLa ? "tip-dezactivat" : ""}>
                                    <td className="tip-denumire">
                                      {e.eticheta || e.codQR}
                                      {e.scosDinFunctiuneLa && (
                                        <span className="eticheta eticheta-inactiv">{tr("scos din funcțiune")}</span>
                                      )}
                                    </td>
                                    <td>{tr(e.tipComponenta.denumire)}</td>
                                    <td>{e.pozitieFizica || "—"}</td>
                                    <td>{e.serie || "—"}</td>
                                    <td>
                                      {!e.garantieExpiraLa ? <span className="fara-pret">{tr("necunoscută")}</span>
                                        : e.inGarantie
                                          ? <span className="pastila pastila-soft">{tr("până la")} {data(e.garantieExpiraLa)}</span>
                                          : <span className="fara-pret">{tr("expirată")} {data(e.garantieExpiraLa)}</span>}
                                    </td>
                                    <td className="celula-actiuni">
                                      <button className="buton-mic" onClick={() => setEchipamentDeschis(e.id)}>{tr("fișa")}</button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ))
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))
          )}
        </>
      )}

      {echipamentDeschis && (
        <FisaEchipament
          id={echipamentDeschis}
          poateAdministra={poateAdministra}
          inchide={() => setEchipamentDeschis(null)}
          reincarca={async () => { await reincarca(); if (cauta) await cautaAcum(cauta); }}
        />
      )}

      {formSistem && clientId && (
        <FormSistem
          clientId={clientId}
          locatii={arbore}
          inchide={() => setFormSistem(false)}
          gata={async () => { setFormSistem(false); await reincarca(); }}
        />
      )}

      {formEchipament && (
        <FormEchipament
          sistem={formEchipament}
          inchide={() => setFormEchipament(null)}
          gata={async () => { setFormEchipament(null); await reincarca(); }}
        />
      )}
    </div>
  );
}

function FisaEchipament({ id, poateAdministra, inchide, reincarca }) {
  const [e, setE] = useState(null);
  const [eroare, setEroare] = useState("");
  const [scoate, setScoate] = useState(false);
  const [motiv, setMotiv] = useState("");
  const [salvez, setSalvez] = useState(false);

  useEffect(() => {
    api.echipament(id).then(setE).catch((er) => setEroare(mesajEroare(er)));
  }, [id]);

  const confirma = async () => {
    setSalvez(true); setEroare("");
    try {
      await api.scoateDinFunctiune(id, { motiv: motiv.trim() });
      setE(await api.echipament(id));
      setScoate(false); setMotiv("");
      await reincarca();
    } catch (er) { setEroare(mesajEroare(er)); }
    finally { setSalvez(false); }
  };

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal modal-lat" onClick={(ev) => ev.stopPropagation()}>
        {!e ? <div className="gol" style={{ padding: "2rem" }}>{tr("Se încarcă…")}</div> : (
          <>
            <h2>{e.eticheta || e.codQR}</h2>
            <p className="subtitlu">
              {tr(e.tipComponenta.denumire)} · {tr(e.subsistem.denumire)} · {tr(e.sistemInstalat.denumire)}
            </p>
            {eroare && <div className="eroare">{eroare}</div>}

            <table className="tabel">
              <tbody>
                <tr><th>{tr("Cod etichetă")}</th><td><code className="cod-mic">{e.codQR}</code></td></tr>
                <tr><th>{tr("Client / locație")}</th><td>{tr(e.client.denumire)} · {tr(e.locatie.denumire)}</td></tr>
                <tr><th>{tr("Poziție")}</th><td>{e.pozitieFizica || "—"}</td></tr>
                <tr><th>{tr("Serie")}</th><td>{e.serie || "—"}</td></tr>
                <tr><th>{tr("Model din catalog")}</th><td>
                  {e.articolCatalog ? `${e.articolCatalog.denumire}${e.articolCatalog.producator ? " · " + e.articolCatalog.producator : ""}`
                    : <span className="fara-pret">{tr("nespecificat")}</span>}
                </td></tr>
                <tr><th>{tr("Instalat la")}</th><td>{data(e.dataInstalarii)} {tr("· sursă:")} {eticheta(SURSA_ECHIPAMENT, e.sursa)}</td></tr>
                <tr><th>{tr("Garanție")}</th><td>
                  {!e.garantieExpiraLa ? <span className="fara-pret">{tr("necunoscută")}</span>
                    : e.inGarantie
                      ? <>{tr("în garanție până la")} <strong>{data(e.garantieExpiraLa)}</strong> ({e.zilePanaLaExpirareGarantie} {tr("zile)")}</>
                      : <>{tr("expirată la")} {data(e.garantieExpiraLa)}</>}
                </td></tr>
                <tr><th>{tr("Ultima mentenanță")}</th><td>{data(e.ultimaMentenanta)}</td></tr>
                <tr><th>{tr("Următoarea")}</th><td>{data(e.urmatoareaMentenanta)}</td></tr>
                {e.scosDinFunctiuneLa && (
                  <>
                    <tr><th>{tr("Scos din funcțiune")}</th><td>{data(e.scosDinFunctiuneLa)}</td></tr>
                    <tr><th>{tr("Motiv")}</th><td>{e.motivScoatere}</td></tr>
                    {e.inlocuitDe && (
                      <tr><th>{tr("Înlocuit de")}</th><td>{e.inlocuitDe.eticheta || e.inlocuitDe.codQR}</td></tr>
                    )}
                  </>
                )}
              </tbody>
            </table>

            <div className="panou">
              <div className="panou-antet"><h2>{tr("Istoric")}</h2><span className="numar">{e.istoric.length}</span></div>
              <div className="panou-corp">
                {e.istoric.length === 0 ? <div className="gol">{tr("Fără evenimente.")}</div> : (
                  e.istoric.map((h) => (
                    <div key={h.id} className="rezultat-context">
                      <strong>{h.eveniment}</strong> · {new Date(h.data).toLocaleString("ro-RO")}
                    </div>
                  ))
                )}
              </div>
            </div>

            {scoate && (
              <div className="panou panou-atentie">
                <div className="panou-corp">
                  <label>
                    {tr("De ce iese din funcțiune?")}
                    <textarea className="camp" rows={2} value={motiv} autoFocus
                      onChange={(ev) => setMotiv(ev.target.value)}
                      placeholder={tr("Defect optic, imagine cețoasă permanent")} />
                  </label>
                  <p className="nota-cautare">
                    {tr("Echipamentul nu se șterge: rămâne în parc, cu istoricul lui, marcat ca scos din funcțiune.")}
                  </p>
                </div>
              </div>
            )}

            <div className="modal-actiuni">
              <button className="buton buton-discret" onClick={inchide}>{tr("închide")}</button>
              {poateAdministra && !e.scosDinFunctiuneLa && (
                scoate
                  ? <button className="buton buton-sters" onClick={confirma} disabled={motiv.trim().length < 5 || salvez}>
                      {salvez ? tr("se scrie…") : tr("confirmă scoaterea")}
                    </button>
                  : <button className="buton buton-sters" onClick={() => setScoate(true)}>{tr("scoate din funcțiune")}</button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function FormSistem({ clientId, locatii, inchide, gata }) {
  const [tipuri, setTipuri] = useState([]);
  const [d, setD] = useState({ locatieId: "", tipSistemId: "", denumire: "", dataPuneriiInFunctiune: "", producatorPrincipal: "", criticitate: "Medie" });
  const [eroare, setEroare] = useState("");
  const [salvez, setSalvez] = useState(false);

  useEffect(() => { api.arbore().then(setTipuri).catch(() => {}); }, []);

  const salveaza = async () => {
    setSalvez(true); setEroare("");
    try {
      await api.creeazaSistemInstalat(clientId, {
        locatieId: d.locatieId, tipSistemId: d.tipSistemId, denumire: d.denumire.trim(),
        ...(d.dataPuneriiInFunctiune ? { dataPuneriiInFunctiune: new Date(d.dataPuneriiInFunctiune).toISOString() } : {}),
        ...(d.producatorPrincipal.trim() ? { producatorPrincipal: d.producatorPrincipal.trim() } : {}),
        criticitate: d.criticitate,
      });
      await gata();
    } catch (e) { setEroare(mesajEroare(e)); setSalvez(false); }
  };

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{tr("Sistem instalat nou")}</h2>
        {eroare && <div className="eroare">{eroare}</div>}
        <div className="formular-linie">
          <label>{tr("Locație")}
            <select className="camp" value={d.locatieId} onChange={(e) => setD({ ...d, locatieId: e.target.value })}>
              <option value="">{tr("— alege —")}</option>
              {locatii.map((l) => <option key={l.id} value={l.id}>{tr(l.denumire)}</option>)}
            </select>
          </label>
          <label>{tr("Tip de sistem")}
            <select className="camp" value={d.tipSistemId} onChange={(e) => setD({ ...d, tipSistemId: e.target.value })}>
              <option value="">{tr("— alege —")}</option>
              {tipuri.map((t) => <option key={t.id} value={t.id}>{tr(t.denumire)}</option>)}
            </select>
          </label>
        </div>
        <label>{tr("Denumire")}<input className="camp" value={d.denumire} placeholder={tr("Supraveghere video — Hala 1")}
          onChange={(e) => setD({ ...d, denumire: e.target.value })} /></label>
        <div className="formular-linie">
          <label>{tr("Pus în funcțiune la")}<input className="camp" type="date" value={d.dataPuneriiInFunctiune}
            onChange={(e) => setD({ ...d, dataPuneriiInFunctiune: e.target.value })} /></label>
          <label>{tr("Producător principal")}<input className="camp" value={d.producatorPrincipal}
            onChange={(e) => setD({ ...d, producatorPrincipal: e.target.value })} /></label>
          <label>{tr("Criticitate")}
            <select className="camp" value={d.criticitate} onChange={(e) => setD({ ...d, criticitate: e.target.value })}>
              {CRITICITATI.map((c) => <option key={c.cod} value={c.cod}>{tr(c.titlu)}</option>)}
            </select>
          </label>
        </div>
        <p className="nota-cautare">
          {tr("Criticitatea ridică severitatea implicită a tichetelor deschise pe acest sistem.")}
        </p>
        <div className="modal-actiuni">
          <button className="buton buton-discret" onClick={inchide}>{tr("renunță")}</button>
          <button className="buton buton-adauga" onClick={salveaza}
            disabled={!d.locatieId || !d.tipSistemId || !d.denumire.trim() || salvez}>
            {salvez ? tr("se salvează…") : tr("salvează")}
          </button>
        </div>
      </div>
    </div>
  );
}

function FormEchipament({ sistem, inchide, gata }) {
  const [arbore, setArbore] = useState([]);
  // Articolele de echipament din catalog. Fără legătura asta, un echipament
  // adăugat manual nu ajunge niciodată la prețul lui: prețul stă pe articol,
  // nu pe exemplarul montat. Serverul o accepta de la început, ecranul o
  // afișa, nota de mai jos o promitea — doar formularul n-o putea seta.
  const [articole, setArticole] = useState([]);
  const [d, setD] = useState({
    tipComponentaId: "", articolCatalogId: "", serie: "", eticheta: "",
    pozitieFizica: "", dataInstalarii: "", garantieLuni: "",
  });
  const [cautaArticol, setCautaArticol] = useState("");
  const [eroare, setEroare] = useState("");
  const [salvez, setSalvez] = useState(false);

  useEffect(() => { api.arbore().then(setArbore).catch(() => {}); }, []);
  useEffect(() => {
    api.articoleLista("Echipament")
      .then(setArticole)
      .catch(() => setArticole([]));
  }, []);

  // Numai tipurile care aparțin sistemului în care montez — restul n-au ce
  // căuta în listă, e greșeala clasică la preluarea unui parc.
  const tipuriPermise = useMemo(() => {
    const s = arbore.find((x) => x.id === sistem.tipSistem?.id || x.cod === sistem.tipSistem?.cod);
    if (!s) return [];
    return s.subsisteme.flatMap((ss) =>
      (ss.tipuriComponenta ?? []).map((t) => ({ ...t, subsistem: ss.denumire })));
  }, [arbore, sistem]);

  const ales = tipuriPermise.find((t) => t.id === d.tipComponentaId);

  // Articolele legate de tipul ales stau primele; cele fără tip declarat
  // rămân disponibile — multe firme nu-și leagă catalogul de nomenclator.
  //
  // Lista se CAUTĂ, nu doar se derulează: un catalog de echipamente importat
  // dintr-o listă de prețuri are mii de poziții, iar un select nativ cu mii
  // de opțiuni e practic imposibil de folosit. Aceeași lecție ca la selectorul
  // de sit din Hub Client.
  const articolePermise = useMemo(() => {
    const q = normalizeaza(cautaArticol);
    const seCaută = (a) => !q || normalizeaza(`${a.cod} ${a.denumire} ${a.producator ?? ""}`).includes(q);
    const potrivite = articole.filter((a) => seCaută(a) && (!d.tipComponentaId || a.tipComponentaId === d.tipComponentaId));
    const restul = articole.filter((a) => seCaută(a) && !a.tipComponentaId && d.tipComponentaId);
    return [...potrivite, ...restul].slice(0, 200);
  }, [articole, d.tipComponentaId, cautaArticol]);
  const articolAles = articole.find((a) => a.id === d.articolCatalogId);

  const salveaza = async () => {
    setSalvez(true); setEroare("");
    try {
      await api.adaugaEchipament(sistem.id, {
        tipComponentaId: d.tipComponentaId,
        ...(d.articolCatalogId ? { articolCatalogId: d.articolCatalogId } : {}),
        ...(d.serie.trim() ? { serie: d.serie.trim() } : {}),
        ...(d.eticheta.trim() ? { eticheta: d.eticheta.trim() } : {}),
        ...(d.pozitieFizica.trim() ? { pozitieFizica: d.pozitieFizica.trim() } : {}),
        ...(d.dataInstalarii ? { dataInstalarii: new Date(d.dataInstalarii).toISOString() } : {}),
        ...(d.garantieLuni ? { garantieLuni: Number(d.garantieLuni) } : {}),
      });
      await gata();
    } catch (e) { setEroare(mesajEroare(e)); setSalvez(false); }
  };

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{tr("Echipament nou —")} {tr(sistem.denumire)}</h2>
        {eroare && <div className="eroare">{eroare}</div>}
        <label>{tr("Tip de componentă")}
          <select className="camp" value={d.tipComponentaId}
            onChange={(e) => setD({ ...d, tipComponentaId: e.target.value })}>
            <option value="">{tr("— alege —")}</option>
            {tipuriPermise.map((t) => (
              <option key={t.id} value={t.id}>{t.subsistem} — {tr(t.denumire)}</option>
            ))}
          </select>
        </label>
        {ales?.necesitaSerie && (
          <p className="nota-cautare">„{tr(ales.denumire)}{tr("\" se urmărește pe serie — seria e obligatorie.")}</p>
        )}
        <label>{tr("Articol din catalog")}
          {articole.length > 8 && (
            <input className="camp" value={cautaArticol} placeholder={tr("caută după cod, denumire sau producător")}
              onChange={(e) => setCautaArticol(e.target.value)} />
          )}
          <select className="camp" value={d.articolCatalogId}
            onChange={(e) => setD({ ...d, articolCatalogId: e.target.value })}>
            <option value="">{tr("— fără articol de catalog —")}</option>
            {articolePermise.map((a) => (
              <option key={a.id} value={a.id}>
                {a.cod} — {tr(a.denumire)}{a.producator ? ` · ${a.producator}` : ""}
              </option>
            ))}
          </select>
        </label>
        {articole.length === 0 ? (
          <p className="nota-cautare">
            {tr("Catalogul n-are încă articole de echipament. Se adaugă din Catalog → Echipamente, manual sau prin import din lista de prețuri a furnizorului. Fără ele, echipamentul se poate monta, dar rămâne fără preț și fără garanție de catalog.")}
          </p>
        ) : (
          <p className="nota-cautare">
            {tr("Articolul e cel care poartă prețul, producătorul și garanția standard.")}
            {articolePermise.length >= 200 ? tr(" Se arată primele 200 — scrie în căutare ca să îngustezi.") : ""}
            {articolAles?.garantieStandardLuni
              ? tr(" „{0}\" are {1} luni de garanție standard.", articolAles.denumire, articolAles.garantieStandardLuni)
              : ""}
          </p>
        )}
        <div className="formular-linie">
          <label>{tr("Serie")}<input className="camp" value={d.serie}
            onChange={(e) => setD({ ...d, serie: e.target.value })} /></label>
          <label>{tr("Etichetă")}<input className="camp" value={d.eticheta} placeholder="CAM-01"
            onChange={(e) => setD({ ...d, eticheta: e.target.value })} /></label>
        </div>
        <label>{tr("Poziție fizică")}<input className="camp" value={d.pozitieFizica}
          placeholder={tr("Hol parter, ax B3")} onChange={(e) => setD({ ...d, pozitieFizica: e.target.value })} /></label>
        <div className="formular-linie">
          <label>{tr("Instalat la")}<input className="camp" type="date" value={d.dataInstalarii}
            onChange={(e) => setD({ ...d, dataInstalarii: e.target.value })} /></label>
          <label>{tr("Garanție (luni)")}<input className="camp" type="number" min="0" value={d.garantieLuni}
            onChange={(e) => setD({ ...d, garantieLuni: e.target.value })} /></label>
        </div>
        <p className="nota-cautare">
          {tr("Lăsată goală, garanția vine din catalog, dacă articolul o are. Data de expirare se calculează din data instalării.")}
        </p>
        <div className="modal-actiuni">
          <button className="buton buton-discret" onClick={inchide}>{tr("renunță")}</button>
          <button className="buton buton-adauga" onClick={salveaza}
            disabled={!d.tipComponentaId || (ales?.necesitaSerie && !d.serie.trim()) || salvez}>
            {salvez ? tr("se salvează…") : tr("salvează")}
          </button>
        </div>
      </div>
    </div>
  );
}
